import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { CreateTransaction } from 'app/dtos/Transaction/createTransaction';
import { UpdateTransaciton } from 'app/dtos/Transaction/updateTransaction';
import { UpdateTransacitonStatus } from 'app/dtos/Transaction/updateTransactionStatus';
import { UpdateTransacitonExpense } from 'app/dtos/Transaction/updateTransactionExpense';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllOfferTransaction(page, size, search, kindId, status?: number, startfilterDate?: string, endFilterDate?: string, companyId?: number) {
    const queryParams = new URLSearchParams({
      Page: page.toString(),
      Size: size.toString(),
      Search: search,
      kindId: kindId.toString(),
      Status: status ? status.toString() : '',
      startfilterDate: startfilterDate ? startfilterDate : '',
      endFilterDate: endFilterDate ? endFilterDate : '',
      companyId: companyId ? companyId.toString() : ''
    }).toString();
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      queryString: queryParams
    });
    return await firstValueFrom(observable);
  }

  async getAllTransactionCompany(page, size, kindId, companyId) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      action: "GetTransactionManagementsCompanies",
      queryString: `Page=${page}&Size=${size}&kindId=${kindId}&CompanyId=${companyId}`,

    });
    return await firstValueFrom(observable);
  }

  async createOffer(createTransaction: CreateTransaction) {
    console.log(createTransaction);
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.TransactionManagement
    }, {
      transactionCraetedAt: createTransaction.startDate,
      validityDate: createTransaction.validityDate,
      status: 1,
      transactionPrivateNode: createTransaction.transactionPrivateNode,
      kindId: createTransaction.kindId,
      companyId: createTransaction.companyId,
      appUserId: createTransaction.userId,
      personId: createTransaction.personId,
      requestTaskId: createTransaction.requestTaskId,
      documentNo: createTransaction.docNo,
      projectId: createTransaction.projectId,
      createTransactionProducts: createTransaction.createTransactionProducts,
      descriptionId: createTransaction.descriptionId,
      isEmailSend: createTransaction.isMailConfirmed,
      expenseId: createTransaction.expenseId
    });
    return await firstValueFrom(observable);
  }

  async getByIdTransaction(id: number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement
    }, id);
    const result = await firstValueFrom(observable);

    if (!result) {
      console.error('Veri bulunamadı!');
      return null;  // Eğer veri yoksa null dönebilirsiniz
    }

    return result;
  }


  async ByIdUpdateDetailTransaction(id: number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      action: "GetByIdTransactionManagementUpdateDetail"
    }, id);
    return await firstValueFrom(observable);
  }

  async ByIdUserDetailTransaction(id: number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      action: "GetByIdTransactionManagementUserDetail"
    }, id);
    return await firstValueFrom(observable);
  }

  async UpdateTransactionStatus(updateTransactionStatus: UpdateTransacitonStatus) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.TransactionManagement,
      action: "UpdateTransactionManagementStatus"
    },
      {
        id: updateTransactionStatus.id,
        kindId: updateTransactionStatus.kindId,
        status: updateTransactionStatus.status
      });
    return await firstValueFrom(observable);
  }

  async UpdateDetailTransactionMagenemnt(updateTransaction: UpdateTransaciton) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.TransactionManagement,
    }, {
      id: updateTransaction.id,
      startDate: updateTransaction.startDate,
      endDate: updateTransaction.endDate,
      requestTaskId: updateTransaction.requestTaskId,
      transactionPrivateNode: updateTransaction.transactionPrivateNode,
      personId: updateTransaction.personId,
      documentNo: updateTransaction.docNo,
      projectId: updateTransaction.projectId,
      projectTransactionManagementId: updateTransaction.projectTransactionManagementId ?? null,
      descriptionId: updateTransaction.descriptionId,
      selectedDescriptionId: updateTransaction.selectedDescriptionId,
      expenseId: updateTransaction.expenseId,
      expenseTransactionId: updateTransaction.expenseTransactionId
    });
    return await firstValueFrom(observable);
  }

  async UpdateDetailTransactionMagenemntExpense(updateTransactionExpense: UpdateTransacitonExpense) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.TransactionManagement,
      action: "UpdateTransactionManagementExpense"
    },
      {
        id: updateTransactionExpense.id,
        projectId: updateTransactionExpense.projectId,
        docNo: updateTransactionExpense.docNo ?? null,
        description: updateTransactionExpense.description,
        transactionManagementProductId: updateTransactionExpense.transactionManagementProductId,
        taxId: updateTransactionExpense.taxId,
        salePrice: updateTransactionExpense.salePrice,
        expenseId: updateTransactionExpense.expenseId,
        expenseTransactionId: updateTransactionExpense.expenseTransactionId,
        transactionCreatedDate: updateTransactionExpense.date
      });
    return await firstValueFrom(observable);
  }


  async GetTransactionManagementExpenseList(page, size, search) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      action: "GetTransactionManagementExpenseList",
      queryString: `Page=${page}&Size=${size}&Search=${search}`
    });
    return await firstValueFrom(observable);
  }

  async getAllTransactionFixtures(page,size,search){
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      action: "GetAllTransactionManagementFixtures",
      queryString: `Page=${page}&Size=${size}&Search=${search}`
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }

}
